/**
 * AM-026 Rule PWD-01 — Change Password Modal for current user.
 */

import { useState } from 'react';
import { useChangeMyPassword } from '../api/am026';

interface ChangePasswordModalProps {
  open: boolean;
  onClose: () => void;
}

export function ChangePasswordModal({ open, onClose }: ChangePasswordModalProps) {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [localError, setLocalError] = useState<string | null>(null);

  const { mutate, isPending, error, isSuccess, reset } = useChangeMyPassword();

  if (!open) return null;

  const handleClose = () => {
    setOldPassword('');
    setNewPassword('');
    setConfirmPassword('');
    setLocalError(null);
    reset();
    onClose();
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setLocalError(null);

    if (newPassword !== confirmPassword) {
      setLocalError('رمز جدید و تکرار آن یکسان نیستند.');
      return;
    }
    if (newPassword.length < 8) {
      setLocalError('رمز جدید باید حداقل ۸ کاراکتر باشد.');
      return;
    }

    mutate(
      { old_password: oldPassword, new_password: newPassword },
      { onSuccess: () => setTimeout(handleClose, 1200) },
    );
  };

  return (
    <div role="dialog" aria-label="تغییر رمز عبور" className="am026-modal">
      <h2>تغییر رمز عبور</h2>
      <form onSubmit={handleSubmit}>
        <label htmlFor="old_password">رمز عبور فعلی</label>
        <input
          id="old_password"
          type="password"
          value={oldPassword}
          onChange={(e) => setOldPassword(e.target.value)}
          required
        />

        <label htmlFor="new_password">رمز عبور جدید</label>
        <input
          id="new_password"
          type="password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          required
        />

        <label htmlFor="confirm_password">تکرار رمز عبور جدید</label>
        <input
          id="confirm_password"
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
        />

        {localError && <p role="alert">{localError}</p>}
        {error && (
          <p role="alert">
            رمز عبور فعلی نادرست است یا خطایی رخ داد.
          </p>
        )}
        {isSuccess && <p role="status">رمز عبور با موفقیت تغییر کرد.</p>}

        <div className="am026-modal-actions">
          <button type="button" onClick={handleClose} disabled={isPending}>
            انصراف
          </button>
          <button type="submit" disabled={isPending}>
            {isPending ? 'در حال ذخیره...' : 'ذخیره'}
          </button>
        </div>
      </form>
    </div>
  );
}
